import React from "react";
import { Dialog, DialogContent } from "./ui/dialog";
import { HOW_STEPS } from "../mock";
import { Play } from "lucide-react";

export default function VideoModal({ open, onOpenChange }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#0e1311] border-[#2fd645]/25 text-white sm:max-w-2xl p-0 overflow-hidden">
        <div className="relative aspect-video bg-black flex items-center justify-center id-grid-bg">
          <div className="absolute inset-0" style={{ background: "radial-gradient(500px circle at 50% 50%, rgba(47,214,69,0.18), transparent 60%)" }} />
          <div className="relative text-center">
            <div className="mx-auto h-20 w-20 rounded-full bg-[#2fd645] flex items-center justify-center">
              <Play className="h-9 w-9 text-[#06210b]" fill="currentColor" />
            </div>
            <p className="mt-5 text-white/70 max-w-sm mx-auto px-4">
              Product walkthrough coming soon. Here&apos;s how InstantDrive works in three simple steps.
            </p>
          </div>
        </div>
        <div className="p-6 grid sm:grid-cols-3 gap-4">
          {HOW_STEPS.map((s, i) => {
            const Icon = s.icon;
            return (
              <div key={s.title} className="rounded-2xl border border-white/10 bg-[#0a0e0c] p-4">
                <div className="flex items-center gap-2">
                  <Icon className="h-5 w-5 text-[#2fd645]" />
                  <span className="text-xs font-bold text-[#2fd645]">STEP {i + 1}</span>
                </div>
                <div className="mt-2 font-semibold text-white text-sm">{s.title}</div>
              </div>
            );
          })}
        </div>
      </DialogContent>
    </Dialog>
  );
}
